var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.42 6.5-1.7-3.17a1.95 1.95 0 0 0-3.44 0L8.58 6.5c-.28.52-.79.9-1.38 1l-3.59.6a1.92 1.92 0 0 0-1.06 3.24l2.54 2.58c.42.43.61 1.02.53 1.61L5.1 19.1a1.94 1.94 0 0 0 2.78 2l3.26-1.59a1.96 1.96 0 0 1 1.72 0l3.26 1.59c1.4.68 3-.47 2.78-2l-.52-3.56a1.9 1.9 0 0 1 .53-1.61l2.54-2.58a1.92 1.92 0 0 0-1.06-3.23L16.8 7.5a1.9 1.9 0 0 1-1.38-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.42 6.5-1.7-3.17a1.95 1.95 0 0 0-3.44 0L8.58 6.5c-.28.52-.79.9-1.38 1l-3.59.6a1.92 1.92 0 0 0-1.06 3.24l2.54 2.58c.42.43.61 1.02.53 1.61L5.1 19.1a1.94 1.94 0 0 0 2.78 2l3.26-1.59a1.96 1.96 0 0 1 1.72 0l3.26 1.59c1.4.68 3-.47 2.78-2l-.52-3.56a1.9 1.9 0 0 1 .53-1.61l2.54-2.58a1.92 1.92 0 0 0-1.06-3.23L16.8 7.5a1.9 1.9 0 0 1-1.38-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavLine);
export default __webpack_public_path__ + "static/media/fav_line.7bb791aeda5120d271725d8b615a8b92.svg";
export { ForwardRef as ReactComponent };